/**
 * DOM ids for a11y wiring (tablist ↔ tabpanel, pricing sheet title focus).
 * Kept in one place so tests and components do not drift apart.
 */
export const ELITE_PLANS_TAB_PANEL_ID = 'elite-plans-tabpanel'

export const ELITE_PLANS_PRICING_DETAILS_TITLE_ID = 'elite-plans-pricing-details-title'

export const ELITE_PLANS_ALLOCATION_CATEGORIES_TITLE_ID =
  'elite-plans-allocation-categories-title'
